/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-08-25 10:46:28
 *
 *******************************************************/

import RankingBanner from 'src/assets/images/advance-search/ranking-banner.png';
import AiSynonymBanner from 'src/assets/images/advance-search/ai-synonyms-banner.png';
import ScopedSuggestionBanner from 'src/assets/images/advance-search/scoped-suggestion-banner.png';
import SemanticBanner from 'src/assets/images/advance-search/semantic-banner.png';

export const StandardSearchTab = {
  relevanceSettings: 'relevance-settings',
  instantSearchWidget: 'instant-search-widget',
  searchResultsPage: 'search-results-page',
  inCollection: 'in-collection',
  manualSynonyms: 'manual-synonyms',
  newManualSynonyms: 'new-manual-synonyms',
  editManualSynonyms: 'edit-manual-synonyms',
  stopWords: 'stop-words',
  redirects: 'redirects',
  newRedirects: 'new-redirects',
  editRedirects: 'edit-redirects',
  suggestionDictionary: 'suggestion-dictionary',
  newSuggestionDictionary: 'new-suggestion-dictionary',
  editSuggestionDictionary: 'edit-suggestion-dictionary'
};

export const AdvanceSearchTab = {
  aiSynonyms: 'ai-synonyms',
  semanticSearch: 'semantic-search',
  productPerformanceRanking: 'product-performance-ranking',
  searchPersonalization: 'search-personalization'
};

export const AdvanceSearchFeaturePreview = [
  {
    name: 'ranking',
    image: RankingBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.ranking_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.ranking_content'
  },
  {
    name: 'semantic',
    image: SemanticBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.semantic_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.semantic_content'
  },
  {
    name: 'aiSynonyms',
    image: AiSynonymBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.aiSynonyms_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.aiSynonyms_content'
  },
  {
    name: 'scopedSuggestion',
    image: ScopedSuggestionBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.scopeSuggestion_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.scopeSuggestion_content'
  }
];
export const MAXIMUM_RE_RANK_ITEMS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
